import { useEffect } from "react";
import { UseQueryResult } from "react-query";
import { useCompanyInfo } from "../../hooks/company.hooks";
import { useMyInfo } from "../../hooks/user.hooks";
import { sentryService } from "../../utils/sentry-service";

const SentryIdentity = () => {
  const { data: myInfo } = useMyInfo();
  const { data: companyInfo } = useCompanyInfo() as UseQueryResult<any, unknown>;

  useEffect(() => {
    if (myInfo) {
      const { id, email, firstName, lastName } = myInfo;
      const fullName = `${firstName || ""} ${lastName || ""}`.trim();

      const domain = companyInfo?.domain || "root";

      // Set user context
      sentryService.setUser({
        id,
        email,
        username: fullName,
        company_domain: domain,
      });

      // Set tags
      sentryService.setTag("company_domain", domain);
      sentryService.setTag("app", "frontend-app");

      const releaseVersion = process.env.GATSBY_APP_VERSION || "unknown";
      sentryService.setTag("release_version", releaseVersion);
    }
  }, [myInfo, companyInfo]);

  return null;
};

export default SentryIdentity;
